module.exports = __webpack_public_path__ + "static/media/facebook-cast.f6300ec7.png";